import axios from "axios";
import { serverApi } from "../../../config/Keys";
import {
  CLEAR_ERRORS,
  CLEAR_LOADER,
  SET_LOADER,
  SUPER_ADMIN_REFREES,
  SUPER_ADMIN_REFERRALS,
  SUPER_ADMIN_VENDOR_REFERRALS,
  SUPER_ADMIN_SALES_REFERRALS,
  SUPER_ADMIN_AFFILIATES_REFERRALS,
  SUPER_ADMIN_PARTNERS_REFERRALS,
  SUPER_ADMIN_REFERRAL_CODES,
} from "../../types";
import { setErrors } from "../errorActions";

/******************************
 * @DESC SUPER ADMIN REFEREES
 ******************************/

export const superadmin_referrals_add =
  (formData, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const refreedata = await axios.post(
        `${serverApi}/refree-service`,
        formData,
        {
          headers: { Authorization: token },
        }
      );
      if (refreedata.status === 201) {
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const superadmin_refrees_get = (token) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    const refreedata = await axios.get(`${serverApi}/refree-service`, {
      headers: { Authorization: token },
    });
    // console.log(refreedata);
    if (refreedata.status === 200) {
      dispatch({
        type: SUPER_ADMIN_REFREES,
        payload: refreedata.data,
      });
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const superadmin_refrees_delete =
  (token, refree_id, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const refreedata = await axios.delete(
        `${serverApi}/refree-service/${refree_id}`,
        {
          headers: { Authorization: token },
        }
      );
      if (refreedata.status === 200) {
        // console.log(refreedata);
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const superadmin_refrees_change_status =
  (token, refree_id, formData, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const refreedata = await axios.patch(
        `${serverApi}/refree-service/${refree_id}`,
        formData,
        {
          headers: { Authorization: token },
        }
      );
      if (refreedata.status === 200) {
        // console.log(refreedata);
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/******************************
 * @DESC SUPER ADMIN ALL REFERRALS
 ******************************/

export const superadmin_refrrals_get =
  (token, role, startDate, endDate) => async (dispatch) => {
    if (startDate && endDate) {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });
      try {
        const referralsdata = await axios.get(
          `${serverApi}/invite-friend?role=${role}&startDate=${startDate}&endDate=${endDate}`,
          {
            headers: { Authorization: token },
          }
        );
        // console.log(referralsdata);
        if (referralsdata.status === 200) {
          if (role === "USER") {
            dispatch({
              type: SUPER_ADMIN_REFERRALS,
              payload: referralsdata.data,
            });
            dispatch({ type: CLEAR_LOADER });
          } else if (role === "VENDOR") {
            dispatch({
              type: SUPER_ADMIN_VENDOR_REFERRALS,
              payload: referralsdata.data,
            });
            dispatch({ type: CLEAR_LOADER });
          } else if (role === "Sales") {
            dispatch({
              type: SUPER_ADMIN_SALES_REFERRALS,
              payload: referralsdata.data,
            });
            dispatch({ type: CLEAR_LOADER });
          } else if (role === "Affiliates") {
            dispatch({
              type: SUPER_ADMIN_AFFILIATES_REFERRALS,
              payload: referralsdata.data,
            });
            dispatch({ type: CLEAR_LOADER });
          } else if (role === "Partners") {
            dispatch({
              type: SUPER_ADMIN_PARTNERS_REFERRALS,
              payload: referralsdata.data,
            });
            dispatch({ type: CLEAR_LOADER });
          }
        }
      } catch (err) {
        dispatch({ type: CLEAR_LOADER });
        dispatch(setErrors(err));
      }
    }
  };

/************************************
 * @DESC SUPER ADMIN REFERRAL CODES
 ************************************/

export const superadmin_referral_codes_add =
  (formData, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const refreedata = await axios.post(
        `${serverApi}/referralcode`,
        formData,
        {
          headers: { Authorization: token },
        }
      );
      if (refreedata.status === 201) {
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const superadmin_refree_get_with_mobile_number =
  (token, country_code, mobile_number, role, onSuccess, onError) =>
  async (dispatch) => {
    try {
      const refreedata = await axios.get(
        `${serverApi}/refree-service?country_code=${country_code}&role=${role}&mobile_number=${mobile_number}`,
        {
          headers: { Authorization: token },
        }
      );
      // console.log(refreedata);
      if (refreedata.status === 200) {
        if (onSuccess) {
          onSuccess(refreedata.data);
        }
      } else if (refreedata.status === 204) {
        onError({ message: "No user found!!" });
      }
    } catch (err) {
      if (onError) {
        onError(err && err.response && err.response.data);
      }
      dispatch(setErrors(err));
    }
  };

export const superadmin_referral_codes_get = (token) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    const refreedata = await axios.get(`${serverApi}/referralcode`, {
      headers: { Authorization: token },
    });
    if (refreedata.status === 200) {
      dispatch({
        type: SUPER_ADMIN_REFERRAL_CODES,
        payload: refreedata.data,
      });
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const superadmin_referral_code_delete =
  (token, referral_code_id, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const refreedata = await axios.delete(
        `${serverApi}/referralcode/${referral_code_id}`,
        {
          headers: { Authorization: token },
        }
      );
      if (refreedata.status === 200) {
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const superadmin_referral_code_edit =
  (token, refree_id, formData, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const refreedata = await axios.patch(
        `${serverApi}/referralcode/${refree_id}`,
        formData,
        {
          headers: { Authorization: token },
        }
      );
      if (refreedata.status === 200) {
        // console.log(refreedata);
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/************************************
 * @DESC SUPER ADMIN ADD REFERRALS
 ************************************/

export const superadmin_referrals_main_add =
  (formData, token, onSuccess, onError) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      const refreedata = await axios.post(
        `${serverApi}/referral-service`,
        formData,
        {
          headers: { Authorization: token },
        }
      );
      if (refreedata.status === 201) {
        onSuccess();
      }
    } catch (err) {
      if (onError) {
        onError(err && err.response && err.response.data);
      }
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
